export default function StepQrCode({ qrcode }) {
  if (!qrcode) {
    return (
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <p style={{ margin: 0, fontWeight: 600 }}>
          Gerando novo QR Code...
        </p>
        <p style={{ marginTop: 6, color: "#666" }}>
          Leia novamente quando aparecer.
        </p>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center" }}>
      <img
        src={qrcode}
        alt="QR Code"
        style={{
          width: 240,
          height: 240,
          marginTop: 20,
          borderRadius: 8,
          border: "1px solid #ddd",
        }}
      />
    </div>
  );
}
